var React = require('react');

function Chevron (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M6.27442 5.58631L10.8869 0.961018C11.038 0.809476 11.0377 0.564125 10.8861 0.412837C10.7346 0.261666 10.4891 0.262056 10.338 0.413618L5.99998 4.7636L1.66203 0.413461C1.51086 0.261919 1.26553 0.261528 1.11397 0.41268C1.03799 0.48852 1 0.587875 1 0.68723C1 0.786331 1.03774 0.885296 1.11319 0.960998L5.72557 5.58631C5.79819 5.6593 5.89701 5.70026 5.99998 5.70026C6.10295 5.70026 6.20166 5.65918 6.27442 5.58631Z","fill":"#135FD2","stroke":"#135FD2","strokeWidth":"0.5"}));
}

Chevron.defaultProps = {"width":"12","height":"6","viewBox":"0 0 12 6","fill":"none"};

module.exports = Chevron;

Chevron.default = Chevron;
